export default __webpack_public_path__ + "7a78e98cebee4d5155d296752b3cabf3.png";